import React from 'react';
import { Link } from 'react-router-dom';

const PaymentCancel = () => {
	return (
		<div className='min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4'>
			<div className='max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-10 text-center'>
				<div className='text-6xl mb-6'>❌</div>
				<h1 className='text-3xl font-bold text-gray-900 dark:text-white mb-3'>
					Payment Cancelled
				</h1>
				<p className='text-gray-600 dark:text-gray-300 mb-8'>
					No charges were made. You can choose a plan whenever you're ready.
				</p>
				<Link
					to='/'
					className='inline-block bg-teal-500 hover:bg-teal-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200'
				>
					Back to Homepage
				</Link>
			</div>
		</div>
	);
};

export default PaymentCancel;